import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { colorMap, lessonsPalette } from '@mirinae/lessons/modules/defines/styles';
import Element from '@mirinae/lessons/components/lesson/elements/Element';

const PhraseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
`;

const AnnotationRow = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 100px;
    width: 500px;
`;

const KoreanRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 500px;
`;

const EnglishRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 500px;
`;

const ControlRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 500px;
`;

const WordWrapper = styled.div`
    position: relative;
    display: inline;
    //border: thin solid #c5dceb;
    //padding: 4px;
`;

const Word = styled.span`
    //margin: 0 2px 0 2px;
    color: ${props => colorMap[props.part.color]};
    // border-bottom: ${props => (props.part.annotation ? 'solid black 4px' : 'none')}; 
    //padding: 4px;
    //border: thin solid #eedbd5;
`;

const StepperWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    //padding: 4px;
    //border: thin solid #d8ebb5;
`;

const StepperButton = styled.div`
    width: 30px;
    cursor: pointer;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    padding: 4px;
    background-color: ${lessonsPalette.grey[4]};;
    border: thin solid gray;
    border-radius: 5px;
    margin: 20px;
    opacity: ${props => (props.disabled ? 0.25 : 1.0)};
    &:hover {
        background-color: ${props => (props.disabled ? 'lightgrey' : 'rgba(172,198,214,0.56)')};
    }
`;

const Stepper = ({ state, onNext, onBack }) => (
    <StepperWrapper>
        <StepperButton disabled={state === 0} onClick={onBack}>{'<'}</StepperButton>
        <StepperButton disabled={state === 3} onClick={onNext}>{'>'}</StepperButton>
    </StepperWrapper>
);

const PhraseWord = ({ part, element, state }) => {

    return part.value && state >= 0 ? (
        <WordWrapper>
            <Word part={part} element={element}>{ part.value}</Word>
        </WordWrapper>
    ) : null;
};

// const PartsWrapper = styled.div`
//     display: flex;
//     flex-direction: column;
//     align-content: center;
// `;


const KoreanParts = styled.div`
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 50px;
`;

const KoreanPartsFadeIn = styled(KoreanParts)`
    position: absolute;
    animation: fadeIn 1s ease-in-out forwards;
    @keyframes fadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
    }
`;

const KoreanPartsFadeOut = styled(KoreanParts)`
    animation: fadeOut 1s ease-in-out forwards;
    @keyframes fadeOut {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
`;

const EnglishParts = styled.div`
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    color: black;
    font-size: 20px;
    text-align: center;
    //border: thin solid red;
    //padding: 4px;
`;

const RisingVowel = styled.div`
    position: absolute;
    background-color: ${lessonsPalette.darken[1]};
    color: white;
    padding: 5px;
    border-radius: 4px;
    
    animation: risingVowel 0.75s ease-in-out forwards;
    @keyframes risingVowel {
        0% { 
            bottom: -20px;
            left: calc(50% - 15px);
            opacity: 0;
        }
        100% {
            bottom: 25px;
            left: calc(50% - 15px);
            opacity: 1;
        }
    }
`;

const Abbreviation = styled.div`
`;

// const PhraseParts = ({ element, parts, fade, state }) => {
//     return (
//         <PartsWrapper>
//             <KoreanParts fade={fade}>
//                 { parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />) }
//             </KoreanParts>
//             { parts.englishParts.some(p => p.value) && (
//                 <EnglishParts>
//                     {parts.englishParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />)}
//                 </EnglishParts>
//             )}
//         </PartsWrapper>
//     );
// };

const TransitioningPhrase = ({ element }) => {
    // const player = useContext(PlayerContext);
    const [state, setState] = useState(0);
    const [risingVowel, setRisingVowel] = useState('');
    const [abbreviation, setAbbreviation] = useState('');


    // const stateRowData = [{ }, { }, { }];

    // compute the overall layout
    // display is 4 flex rows (annotation, korean, english, controls) with content centered in a flex column
    // for each row there are 4 possible states, set by the 'state' useState var: 0: fromPhrase, 1: rising vowel, 2: 다 going & cross-dissolve to toPhrase,
    //   3: annotations over toPhrase, 4: cross-dissolve to shortenedPhrase.
    // useEffect(() => {
    //     // let x = 0; let y = 0;
    //     let maxWidth = 0;
    //     //
    //     if (!element.fieldsByName.fromPhrase.hidden) {
    //         const parts = element.fieldsByName.fromPhrase.parts;
    //         const metrics = getMetricsForStrings(parts.koreanParts.map(p => p.value), 'lesson-korean-phrase-large');
    //         maxWidth = Math.max(metrics.map(m => m.width));
    //     }
    //     if (!element.fieldsByName.toPhrase.hidden) {
    //         const parts = element.fieldsByName.toPhrase.parts;
    //         const metrics = getMetricsForStrings(parts.koreanParts.map(p => p.value), 'lesson-korean-phrase-large');
    //         maxWidth = Math.max(metrics.map(m => m.width));
    //     }
    //     if (!element.fieldsByName.shortenedPhrase.hidden) {
    //         const parts = element.fieldsByName.shortenedPhrase.parts;
    //         const metrics = getMetricsForStrings(parts.koreanParts.map(p => p.value), 'lesson-korean-phrase-large');
    //         maxWidth = Math.max(metrics.map(m => m.width));
    //     }
    // }, [element]);

    // bump conjugation mini-steps
    const onBump = (bump) => {
        let newState = state + bump;
        if (newState === 1) {
            // check for rising vowel annotations & animate it during state 1, else skip
            const vowelPart = element.fieldsByName.fromPhrase.parts.koreanParts.find(kp => kp.annotation.match(/\$vowel:/));
            if (vowelPart)
                setRisingVowel(vowelPart.annotation[vowelPart.annotation.length - 1]);
            else
                newState += bump;
        } else if (newState === 2) {
            // check for abbreviation
            const shortenedParts = element.fieldsByName.toPhrase.parts.koreanParts.filter(kp => kp.shortened);
            if (shortenedParts) {
                setAbbreviation('Abbreviated');
            }
        }
        if (newState < 4 && newState >= 0)
            setState(newState);
    };

    return (
        <Element element={element} style={{ minWwidth: 500 }}>
            <PhraseWrapper>
                <AnnotationRow>{
                    (state === 1 && risingVowel ? (
                        <RisingVowel>{risingVowel}</RisingVowel>
                    ) : (state === 3 && abbreviation && (
                        <Abbreviation>{abbreviation}</Abbreviation>
                    )))
                }
                </AnnotationRow>
                <KoreanRow>{
                    (state === 0 ? (
                        <KoreanParts fade="">
                            { element.fieldsByName.fromPhrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} state={state} />) }
                        </KoreanParts>
                    ) : (state === 1 ? (
                        <>
                            <KoreanParts>
                                { element.fieldsByName.fromPhrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} state={state} />) }
                            </KoreanParts>
                        </>
                    ) : (state === 2 ? (
                        <>
                            <KoreanPartsFadeOut>
                                { element.fieldsByName.fromPhrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} state={state} />) }
                            </KoreanPartsFadeOut>
                            <KoreanPartsFadeIn>
                                { element.fieldsByName.toPhrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} state={state} />) }
                            </KoreanPartsFadeIn>
                        </>
                    ) : (state === 3 && (
                        <>
                            <KoreanPartsFadeOut>
                                { element.fieldsByName.toPhrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} state={state} />) }
                            </KoreanPartsFadeOut>
                            <KoreanPartsFadeIn>
                                { element.fieldsByName.shortenedPhrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} state={state} />) }
                            </KoreanPartsFadeIn>
                        </>
                    )))))
                }
                </KoreanRow>
                <EnglishRow>{
                    (state === 0 ? (
                        <EnglishParts>
                            {element.fieldsByName.fromPhrase.parts.englishParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />)}
                        </EnglishParts>
                    ) : (state === 1 ? (
                        <>
                            <EnglishParts>
                                { element.fieldsByName.fromPhrase.parts.englishParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />) }
                            </EnglishParts>
                        </>
                    ) : (state === 2 ? (
                        <>
                            <EnglishParts>
                                {element.fieldsByName.toPhrase.parts.englishParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />)}
                            </EnglishParts>
                        </>
                    ) : (state === 3 && (
                        <>
                            <EnglishParts>
                                {element.fieldsByName.shortenedPhrase.parts.englishParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />)}
                            </EnglishParts>
                        </>
                    )))))
                }
                </EnglishRow>
                <ControlRow>
                    <Stepper state={state} onNext={() => onBump(1)} onBack={() => onBump(-1)} />
                </ControlRow>
            </PhraseWrapper>
        </Element>
    );
};

export default TransitioningPhrase;
